import { FunctionComponent, memo, useMemo } from "react";
import { Box, BoxContent } from "@edgetier/client-components";

import { SpinnerUntil } from "@edgetier/components";
import PermissionsTableBody from "./permissions-table-body";
import RoleList from "components-for/roles/role-list";
import { useAllRolesPermissions } from "hooks-for/permissions/use-role-permissions";
import { IProps } from "./permissions-table.types";
import "./permissions-table.scss";

/**
 * Display a scrollable table with roles and permissions
 * @param props.roles           List of all roles from database
 * @param props.permissions     List of all permissions
 */
const PermissionsTable: FunctionComponent<IProps> = ({ roles, permissions }) => {
    // Retrieve all permissions for all roles
    const allRolesPermissions = useAllRolesPermissions(roles);

    // Look for any loading requests
    const isAllRolesPermissionsLoading = useMemo(() => allRolesPermissions.some(({ isLoading }) => isLoading), [
        allRolesPermissions,
    ]);

    return (
        <>
            <div className="permissions-table">
                <Box className="permissions-table__box">
                    <BoxContent
                        className="permissions-table__box-content"
                        horizontalPadding={false}
                        verticalPadding={false}
                    >
                        <SpinnerUntil<{ [index: string]: any }>
                            data={allRolesPermissions}
                            isReady={!isAllRolesPermissionsLoading}
                        >
                            {(data) => (
                                <table className="permissions-table__table">
                                    <thead>
                                        <tr>
                                            <th>Permissions</th>
                                            <RoleList roles={roles} />
                                        </tr>
                                    </thead>

                                    <PermissionsTableBody
                                        roles={roles}
                                        permissions={permissions}
                                        rolePermissions={data.map(
                                            (responseRole: { [index: string]: any }) => responseRole.data
                                        )}
                                    />
                                </table>
                            )}
                        </SpinnerUntil>
                    </BoxContent>
                </Box>
            </div>
        </>
    );
};

export default memo(PermissionsTable);
